var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 50,
    viewBox: "0 0 67 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6332 37.75C28.2957 37.75 32.0457 34.075 32.0457 28.675V21.3625C32.0457 15.9625 28.2582 12.25 22.6332 12.25C17.0457 12.25 13.2582 15.925 13.2582 21.3625V28.675C13.2582 34.075 17.0082 37.75 22.6332 37.75ZM22.6332 34.4875C18.9582 34.4875 16.7832 32.3125 16.7832 28.5625V21.5125C16.7832 17.725 18.9582 15.5125 22.6332 15.5125C26.3457 15.5125 28.5582 17.725 28.5582 21.5125V28.5625C28.5582 32.2375 26.3082 34.4875 22.6332 34.4875Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4358 12.7H50.6858L44.3858 23.2375H40.4858V12.7H36.9608V37.3H40.4858V26.425H44.2358L50.6483 37.3H54.3983V36.7375L47.3483 24.9625L54.4358 13.2625V12.7Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.3125,
    y: 1.5,
    width: 62.625,
    height: 47,
    stroke: "black",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.72cfd7906dd488241a083c963f4db3a1.svg";
export { ForwardRef as ReactComponent };